"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyLoad = exports.Loader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const I18n_1 = require("../../i18n/I18n");
const Suspense_1 = require("../suspense/Suspense");
const Loader = () => {
    const { t } = I18n_1.useTranslation();
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: t("Loading") }, void 0);
};
exports.Loader = Loader;
function lazyLoad(ComponentToLoad) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props) => {
        return Suspense_1.withSuspense(jsx_runtime_1.jsx(ComponentToLoad, Object.assign({}, props), void 0));
    };
}
exports.lazyLoad = lazyLoad;
//# sourceMappingURL=Loader.js.map